// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"4bb43d32","639":"f7f1934f","717":"37507985","768":"f5e577a3","941":"0acb47f1"}[chunkId] + ".chunk.css";
};